import BasicLayout from 'components/atoms/Modal/Basic.Layout';
import { isACtiveVoice } from 'modules/actions/statusMenu';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMobileCheck, sendAudioCtx } from 'lib';
import { startRecord, stopRecord } from 'lib/STT';
import { chatList } from 'modules/actions/chat';


const Voice = () => {
  const dispatch = useDispatch();
  const [mic, setMic] = useState(false);
  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  const audioContent = new AudioContext();
  const [audio, setAudio] = useState(audioContent);

  let audioContext;

  const constentSet = () => {
    const startListening = () => {
      setTimeout(function() {
        setMic(true);
      }, 1000);
     
      if (getMobileCheck() === 'android') {
        startRecord();
      } else{
        console.log('ios');
        audio.createGain();
        audio.resume();
        audio.onstatechange = () => console.log(audio.state);
        startRecord();
      } 
    };

    const stopListening = async () => {
      if (getMobileCheck() === 'android') {
        console.log('android');
        const test = await stopRecord();
        console.log("###stop값",test);
        let voiceYN ='';
        if(test !== '음성인식이 되지 않았습니다'){
          voiceYN = 'y';
        } 
        const paramSet = {
          inType: 'query',
          inStr: test,
          parameters: {
            voiceYN,
          },
        };
        dispatch(chatList(paramSet));
        dispatch(isACtiveVoice());
      }else{
        console.log('ios');
        audioContext = audio;
        audioContext.createGain();
        audioContext.resume();
        sendAudioCtx(audioContext);
        const test = await stopRecord();
        console.log("#####   "+test);
        let voiceYN ='';
        if(test !== '음성인식이 되지 않았습니다'){
          voiceYN = 'y';
        } 
        const paramSet = {
          inType: 'query',
          inStr: test,
          parameters: {
            voiceYN,
          },
        };
        dispatch(chatList(paramSet));
        dispatch(isACtiveVoice());
      } 


    };

    return (
      <>
        <div className="_voice_div">
          <div className="_voice_title">
            {mic === false ? <p style={{fontWeight:'bold'}}>아래의 마이크를 클릭하세요!</p> : <div>듣고있어요 ! <br />또박또박 천천히 질문해주세요. <br /> <p style={{fontWeight:'bold'}}>다시 클릭하면 음성인식이 완료됩니다.</p></div>}
          </div>
          <div className="_voice_mic">
            <div className="_voice_mic_area">
              {mic === false ? (
                <div className="_voice_mic_start" onClick={() => startListening()}>
                  <i className="ri-mic-line" style={{ color: '#fff', fontSize: '50px' }} />
                </div>
              ) : (
                <div className="_icon" onClick={() => stopListening()}>
                  <div className="spinner">
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <BasicLayout
      label=""
      value=""
      labelIcon=""
      viewStatus=""
      styleDef={{
        height: 'auto',
        background: 'linear-gradient(to left, rgb(1, 177, 203), rgb(37, 110, 239))',
        color: '#fff',
        borderRadius: '40px',
        width: '335px',
      }}
      onClickEvt={() => dispatch(isACtiveVoice())}
      error={null}
      contentSet={constentSet}
    />
  );
};
Voice.propTypes = {};
Voice.defaultProps = {};
export default React.memo(Voice);
